import * as React from "react"
// @ts-ignore
import anime from "animejs";

const SplitTextHtml = (text: string, type: string = 'single', aditionalClass: string = '') => {
    const [nwText, setNwText] = React.useState<any>([])

    const replaceTagContent = (fullText: string) => {
        return fullText.replace(/(\r\n|\n|\r)/gm, '').replace(/<\/(div|p|span)>/gi, '').split(/<div>|<p>/gi).filter(text => text != '').map(text => text.split('<span>'))
    }

    const splitLineJump = (fullText: string) => {
        return fullText.split(/<br\s?\/>/gi)
    }

    const splitText = (fullText: string) => {
        return fullText.split(' ')
    }

    const splitWord = (word: string) => {
        return word.split('').map((letter: string) => `<span class='word-split-carousel__char'>${letter}</span>`).join('')

    }

    const checkViewportTitle = () => {
        var targets = document.querySelectorAll('.swiper-title, .swiper-description>div>div, .swiper-description>div>span');
        let options = {
            threshold: 0.7
        }

        let observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                let animation = anime({
                    targets: entry.target.querySelectorAll('.word-split-carousel--fade-up .word-split-carousel__char'),
                    translateY: [50, 0],
                    opacity: [0, 1],
                    autoplay: false,
                    easing: 'easeOutQuart',
                    duration: 800,
                    delay: function (_: any, i: any) {
                        return i * 20
                    }
                })

                animation.finished.then(function () {
                    if (entry.target.classList.contains('word-split-carousel--fade-up')) {
                        entry.target.classList.remove('word-split-carousel--fade-up')
                    }
                    else {
                        let letterList = entry.target.querySelectorAll('.word-split-carousel--fade-up')
                        for (let i = 0; i < letterList.length; i++) {
                            letterList[i].classList.remove('word-split-carousel--fade-up')
                        }
                    }
                })

                if (entry.isIntersecting) {
                    animation.play()
                }
            });
        }, options);

        targets.forEach((target: any) => {
            observer.observe(target);
        })
    }

    const checkSingleText = () => {
        let finalText: any = [];
        let groupLetters: any = [];
        let groupWords: any = [];

        let splitHtmlTags = splitLineJump(text)
        splitHtmlTags.forEach((lines: string) => {
            let splitFullText = splitText(lines)
            groupLetters = splitFullText.map((word: string) => splitWord(word))
            groupWords = groupLetters.map((letter: string) => `<div class='word-split-carousel word-split-carousel--fade-up ${aditionalClass}'>${letter}</div>`)
            finalText.push(groupWords.join(''));
        })
        Promise.resolve()
            .then(() => {
                setNwText(finalText.join('<br/>'))
            })
            .then(() => {
                checkViewportTitle()
            })
    }

    const checkAdvancedText = () => {
        let finalText: string;
        let groupLetters: any = [];
        let groupWords: any = [];
        let splitSections = replaceTagContent(text)
        let contentGroup: any = []

        splitSections.forEach((item, index) => {
            let sectionsComplete: Array<any> = []
            item.forEach((item2) => {
                let splitHtmlTags = splitLineJump(item2)
                let sections: Array<any> = []
                splitHtmlTags.forEach((lines: string) => {
                    let splitFullText = splitText(lines)
                    groupLetters = splitFullText.map((word: string) => splitWord(word)).filter(word => word != '')
                    groupWords = groupLetters.map((letter: string) => `<div class='word-split-carousel word-split-carousel--fade-up'>${letter}</div>`)
                    sections.push(groupWords.join(''));
                })
                sectionsComplete.push(sections)
            })
            
            if (sectionsComplete[1]) {
                sectionsComplete[1] = `<span>${sectionsComplete[1].join('<br/>')}</span>`
                contentGroup.push(`<div>${sectionsComplete.join('')}</div>`)
            }
        })
        finalText = contentGroup.join('')
        Promise.resolve()
            .then(() => {
                setNwText(finalText)
            })
            .then(() => {
                checkViewportTitle()
            })
    }

    React.useEffect(() => {
        if (type == 'single') checkSingleText()
        if (type != 'single') checkAdvancedText()
    }, [text])

    return nwText
}

export default SplitTextHtml